export const censusByIdForLeaderDTOTranslateKey: { [key: string]: string } = {
    CensusId: 'Numer rejestracji',
    Name: 'Imię',
    Surname: 'Nazwisko',
    InstructorRank: 'Stopień instruktorski',
    UnitName: 'Nazwa jednostki',
    RegistrationState: 'Stan rejestracji',
    Request: 'Złożony wniosek',
    VacationStartDate: 'Data rozpoczęcia urlopu',
    VacationEndDate: 'Data zakończenia urlopu',
    RegistrantComment: 'Dodatkowe uwagi składającego',
    StateAwards: 'Odznaczenia państwowe i krzyże honorowe ZHR',
    YPSResidence: 'Oświadczenie - zamieszkanie',
    YPSCitizenship: 'Oświadczenie - obywatelstwo',
    YPSAccept: 'Zaakceptowanie Standardów ochrony małoletnich ZHR',
    YPSKRKSent: 'Oświadczenie - złożenie KRK',
    KRKIssueDate: 'Data wystawienia KRK',
    CreateDate: 'Data przesłania'
}